<template>
  <div v-if="csh" class="app-container" :style="{ background: 'rgba(7, 36, 93, 0.25)', backgroundSize: '100% 100%', }">
    <!-- 头部状态栏 -->
    <header class="header">
      <div class="header-content">
        <h1 class="title">智能施肥系统</h1>
        <div class="status-group">
          <el-button type="text" @click="initsx" class="alarm-btn" style="margin-right: 1vw;">
            <img src="/img/shuaxin.png" class="valve-icon">
          </el-button>
          <el-button type="text" @click="showAlarmDialog" class="alarm-btn">
            <img src="/img/jjzt1.png" class="valve-icon">
          </el-button>
          <p class="time-display">{{ currentDateTime }}</p>
          <el-button @click="openDialog('controlMode')" :class="controlMode" class="mode-btn">
            {{ controlMode === 'local' ? '本地模式' : '远程模式' }}
          </el-button>
          <el-button @click="openDialog('workMode')" :class="workMode" class="mode-btn">
            {{ workMode === 'auto' ? '自动模式' : '手动模式' }}
          </el-button>
        </div>
      </div>
      <img src="/img/线.png" class="header-divider">
    </header>

    <!-- 主内容区 -->
    <main class="main-content">
      <div class="content" :class="{ active: currentTab === 0 }">
        <div class="teb-main">
          <!-- 数据面板 -->
          <div class="left-content">
            <div class="data-panel" :style="{ backgroundImage: 'url(/img/11.png)', backgroundSize: '100% 100%' }">
              <div class="sensor-grid">
                <div class="sensor-item">
                  <div class="sensor-value">{{ dataSource.yali }}</div>
                  <div class="sensor-label">压力(Mpa)</div>
                </div>
                <div class="sensor-item">
                  <div class="sensor-value">{{ dataSource.signalRsrp }}</div>
                  <div class="sensor-label">信号强度</div>
                </div>
                <div class="sensor-item">
                  <div class="sensor-value">{{ dataSource.ec }}</div>
                  <div class="sensor-label">EC(us/cm)</div>
                </div>
                <div class="sensor-item">
                  <div class="sensor-value">{{ dataSource.shunshi }}</div>
                  <div class="sensor-label">瞬时流量(m³/h)</div>
                </div>
                <div class="sensor-item">
                  <div class="sensor-value">{{ dataSource.currentUseTime }}</div>
                  <div class="sensor-label">施肥时长(min)</div>
                </div>
                <div class="sensor-item">
                  <div class="sensor-value">{{ dataSource.ph }}</div>
                  <div class="sensor-label">PH</div>
                </div>
                <div class="sensor-item">
                  <div class="sensor-value">{{ dataSource.leiji }}</div>
                  <div class="sensor-label">累计流量(m³)</div>
                </div>
                <div class="sensor-item">
                  <div class="sensor-value">{{ dataSource.currentUseWater }}</div>
                  <div class="sensor-label">施肥量(m³)</div>
                </div>
              </div>
            </div>
            <div class="device-controls">
              <div class="device-item">
                <span>施肥泵</span>
                <img
                  :src="dataSource.shifeiPumpStatus === 1 ? '/img/zxzt0.png' : dataSource.shifeiPumpStatus === 2 ? '/img/zxzt1.png' : '/img/zxzt2.png'"
                  class="device-icon">
              </div>
              <div class="device-item">
                <span>清洗阀</span>
                <img
                  :src="dataSource.qingxiStatus === 1 ? '/img/zxzt0.png' : dataSource.qingxiStatus === 2 ? '/img/zxzt1.png' : '/img/zxzt2.png'"
                  class="device-icon">
              </div>
              <!-- 按钮 -->
              <el-button @click="openDialog('startMode')" type="success" class="control-btn">启动</el-button>
              <el-button type="danger" @click="openDialog('stopMode')" class="control-btn">停止</el-button>
            </div>
          </div>
          <!-- 肥料桶状态 -->
          <div class="fertilizer-tank" :style="{ backgroundImage: 'url(/img/yk.png)', backgroundSize: '100% 100%' }">

            <div class="right-content">
              <!-- 左按键 -->
              <div class="arrow" style="justify-content: right;">
                <el-image class="arrow-img" @click="prevSlide" src="/img/zjt.png"></el-image>
              </div>
              <div class="tank">
                <div class="tong-status">
                  <span v-for="(item, index) in tong1" :key="index"
                    :style="{ left: index * 100 + '%', transform: dynamicstyle }">{{ item }}
                  </span>
                </div>
                <!-- <h3>施肥机桶A</h3> -->
                <div class="tank-status">
                  <div class="status-item">
                    <span>液位(m³):</span>
                    <span class="value margin-left">{{ currentSlide == 0 ? dataSource.yewei : currentSlide == 1 ? dataSource.yewei2 : dataSource.yewei3 }}</span>
                  </div>
                  <div class="status-item">
                    <span>施肥阀:</span>
                    <img
                      :src="dataSource.shifeiStatus === 1 ? '/img/zxzt0.png' : dataSource.shifeiStatus === 2 ? '/img/zxzt1.png' : '/img/zxzt2.png'"
                      class="valve-icon margin-left">
                  </div>
                  <div class="status-item">
                    <span>加水阀:</span>
                    <img
                      :src="dataSource.jiashuiStatus === 1 ? '/img/zxzt0.png' : dataSource.jiashuiStatus === 2 ? '/img/zxzt1.png' : '/img/zxzt2.png'"
                      class="valve-icon margin-left">
                  </div>
                  <div class="action-group">
                    <el-button type="success" @click="openDialog('waterPlus')" class="tank-btn">加水</el-button>
                    <el-button type="danger" @click="openDialog('waterStop')" class="tank-btn">停止</el-button>
                  </div>
                  <!-- <div class="action-group">
                    <el-button type="success" @click="openDialog('stir')" class="tank-btn">搅拌</el-button>
                    <el-button type="danger" @click="openDialog('stirStop')" class="tank-btn">停止</el-button>
                  </div> -->
                </div>
              </div>
              <!-- 右按键 -->
              <div class="arrow" style="justify-content: left;">
                <el-image class="arrow-img" @click="nextSlide" src="/img/yjt.png"></el-image>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="content" :class="{ active: currentTab === 4 }">
        <div class="tabs-container-small">
          <ul class="tab-nav-small">
            <li class="tab-item-small" :class="{ active: smallTab === 0 }" @click="smallTab = 0">施肥参数</li>
            <li class="tab-item-small" :class="{ active: smallTab === 1 }" @click="smallTab = 1">传感器参数</li>
            <li class="tab-item-small" :class="{ active: smallTab === 2 }" @click="smallTab = 2">泵参数</li>
            <li class="tab-item-small" :class="{ active: smallTab === 3 }" @click="smallTab = 3">通道参数</li>
          </ul>
          <div class="tab-content-small">
            <div class="content-small " :class="{ active: smallTab === 0 }" style="">
              <!-- justify-content:center -->
              <div>
                <div class="tab-main-row">
                  <div class="tab-row-content">
                    <div class="tab-row-font">施&nbsp;&nbsp;&nbsp;肥&nbsp;&nbsp;&nbsp;量：</div>
                    <el-input class="tab-row-input" v-model="input"></el-input>
                  </div>
                  <div class="tab-row-content">
                    <div class="tab-row-font">肥&nbsp;前&nbsp;水&nbsp;量：</div>
                    <el-input class="tab-row-input" v-model="input"></el-input>
                  </div>
                </div>
                <div class="tab-main-row">
                  <div class="tab-row-content">
                    <div class="tab-row-font">施&nbsp;肥&nbsp;时&nbsp;间：</div>
                    <el-input class="tab-row-input" v-model="input"></el-input>
                  </div>
                  <div class="tab-row-content">
                    <div class="tab-row-font">肥&nbsp;后&nbsp;水&nbsp;量：</div>
                    <el-input class="tab-row-input" v-model="input"></el-input>
                  </div>
                </div>
                <div class="tab-main-row">
                  <div class="tab-row-content">
                    <div class="tab-row-font">预设施肥量：</div>
                    <el-input class="tab-row-input" v-model="input"></el-input>
                  </div>
                  <div class="tab-row-content">
                    <div class="tab-row-font">灌&nbsp;溉&nbsp;水&nbsp;量：</div>
                    <el-input class="tab-row-input" v-model="input"></el-input>
                  </div>
                </div>

              </div>
              <div class="tab-button-row">
                <div style="">
                  <el-button class="tab-main-button" @click="openDialog('init')" type="info">清零施肥量</el-button>
                </div>
                <div style="">
                  <el-button class="tab-main-button" @click="openDialog('getParams')" type="info">读取</el-button>
                  <el-button class="tab-main-button" @click="openDialog('setUp')" type="info">设置</el-button>
                </div>
              </div>

            </div>
            <div class="content-small" :class="{ active: smallTab === 1 }">
              <div class="tab-main-row">
                <div class="tab-row-content">
                  <div class="tab-row-font">液位量程：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
                <div class="tab-row-content">
                  <div class="tab-row-font">流量高报：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
              </div>
              <div class="tab-main-row">
                <div class="tab-row-content">
                  <div class="tab-row-font">液位低报：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
                <div class="tab-row-content">
                  <div class="tab-row-font">压力量程：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
              </div>
              <div class="tab-main-row">
                <div class="tab-row-content">
                  <div class="tab-row-font">液位高报：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
                <div class="tab-row-content">
                  <div class="tab-row-font">压力低报：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
              </div>
              <div class="tab-main-row">
                <div class="tab-row-content">
                  <div class="tab-row-font">液位偏移：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
                <div class="tab-row-content">
                  <div class="tab-row-font">压力高报：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
              </div>
              <div class="tab-main-row">
                <div class="tab-row-content">
                  <div class="tab-row-font">流量量程：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
                <div class="tab-row-content">
                  <div class="tab-row-font">肥料密度：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
              </div>
              <div class="tab-main-row">
                <div class="tab-row-content">
                  <div class="tab-row-font">流量低报：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
                <div style="width: 29vw;"></div>
              </div>
              <div style="display: flex; justify-content: flex-end; align-items: center;">
                <el-button class="tab-main-button" @click="openDialog('getParams1')" type="info">读取</el-button>
                <el-button class="tab-main-button" @click="openDialog('setUp1')" type="info">设置</el-button>
              </div>
            </div>
            <div class="content-small" :class="{ active: smallTab === 2 }">
              <div class="tab-main-row">
                <div class="tab-row-content">
                  <div class="tab-row-font">清&nbsp;&nbsp;洗&nbsp;&nbsp;&nbsp;时&nbsp;&nbsp;间：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
                <div class="tab-row-content">
                  <div class="tab-row-font">施肥关阀延时时间：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
              </div>
              <div class="tab-main-row">
                <div class="tab-row-content">
                  <div class="tab-row-font">开泵延时时间：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
                <div class="tab-row-content">
                  <div class="tab-row-font">清洗关阀延时时间：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
              </div>
              <div class="tab-main-row">
                <div class="tab-row-content">
                  <div class="tab-row-font">关泵延时时间：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
                <div class="tab-row-content">
                  <div class="tab-row-font">
                    启&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;动&nbsp;&nbsp;&nbsp;&nbsp;频&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;率：
                  </div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
              </div>
              <div class="tab-main-row">
                <div class="tab-row-content">
                  <div class="tab-row-font">反&nbsp;&nbsp;洗&nbsp;&nbsp;&nbsp;时&nbsp;&nbsp;间：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
                <div class="tab-row-content">
                  <div class="tab-row-font">故障停机延时时间：</div>
                  <el-input class="tab-row-input" v-model="input" placeholder="请输入施肥量"></el-input>
                </div>
              </div>
              <div style="display: flex; justify-content: flex-end; align-items: center;">
                <el-button class="tab-main-button" @click="openDialog('getParams2')" type="info">读取</el-button>
                <el-button class="tab-main-button" @click="openDialog('setUp2')" type="info">设置</el-button>
              </div>
            </div>
            <div class="content-small" :class="{ active: smallTab === 3 }">
              <div class="tab-main-row">
                <el-button class="tab-main-button" type="info" @click="openDialog('dan')">单通道</el-button>
                <el-button class="tab-main-button" type="info" @click="openDialog('sanA')">三通道A</el-button>
                <el-button class="tab-main-button" type="info" @click="openDialog('sanB')">三通道B</el-button>
                <el-button class="tab-main-button" type="info" @click="openDialog('sanC')">三通道C</el-button>
              </div>
              <div class="tab-main-row">
                <el-button class="tab-main-button" type="info" @click="openDialog('sanAB')">三通道AB</el-button>
                <el-button class="tab-main-button" type="info" @click="openDialog('sanAC')">三通道AC</el-button>
                <el-button class="tab-main-button" type="info" @click="openDialog('sanBC')">三通道BC</el-button>
                <el-button class="tab-main-button" type="info" @click="openDialog('sanABC')">三通道ABC</el-button>
              </div>
              <div class="tab-main-row">
                <el-button class="tab-main-button" type="info" @click="openDialog('danshuju')">单通道数据</el-button>
                <el-button class="tab-main-button" type="info" @click="openDialog('bengshuju')">泵房数据</el-button>
                <el-button class="tab-main-button" type="info" @click="openDialog('duoshuju')">多通道数据</el-button>
                <el-button class="tab-main-button" type="info" @click="openDialog('ECPH')">ECPH数据</el-button>
                <el-button class="tab-main-button" type="info" @click="openDialog('duoECPH')">多通道数据_ECPH</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- 底部导航 -->
    <footer class="footer">
      <ul class="nav-tabs">
        <li class="tab-item" :class="{ active: currentTab === 0 }" @click="currentTab = 0">
          <img class="tab-img" :src="currentTab === 0 ? '/img/znsf_1.png' : '/img/znsf_0.png'" alt="tab-icon">
          <div>智能施肥</div>
        </li>
        <li class="tab-item" :class="{ active: currentTab === 4 }" @click="currentTab = 4">
          <img class="tab-img" :src="currentTab === 4 ? '/img/cssz_1.png' : '/img/cssz_0.png'" alt="tab-icon">
          <div>参数设置</div>
        </li>
      </ul>
    </footer>

    <!-- 告警对话框 -->
    <el-dialog :visible.sync="alarmDialogVisible" width="20%">
      <div class="alarm-list">
        <div>
          <div class="text1-3">2025-12-12 12:12:12</div>
          <div>
            <img :src="dataSource.feiYeweiWarn === 0 ? '/img/jjzt1.png' : '/img/jjzt2.png'" class="alarm-status-icon">
            <span class="text1-3 top0-5">肥液位告警</span>
          </div>
          <div>
            <img :src="dataSource.shuiLiuliangWarn === 0 ? '/img/jjzt1.png' : '/img/jjzt2.png'"
              class="alarm-status-icon">
            <span class="text1-3 top0-5">水流量告警</span>
          </div>
          <div>
            <img :src="dataSource.feiLiuliangWarn === 0 ? '/img/jjzt1.png' : '/img/jjzt2.png'"
              class="alarm-status-icon">
            <span class="text1-3 top0-5">肥流量告警</span>
          </div>
          <div>
            <img :src="dataSource.shuiYaliWarn === 0 ? '/img/jjzt1.png' : '/img/jjzt2.png'" class="alarm-status-icon">
            <span class="text1-3 top0-5">水压力告警</span>
          </div>

        </div>

      </div>
    </el-dialog>

    <!-- 对话框 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <div v-if="currentMode === 'startMode'">
        <div v-if="workMode !== 'auto'">
          <div class="flex" style="justify-content: left; margin: 10px; white-space: pre-wrap">
            施&nbsp;肥&nbsp;量：
            <el-input :disabled="startForm.ferTime != ''" type="number" style="width: 200px;" v-model="startForm.ferAmount" placeholder="请输入施肥量"></el-input>
          </div>
          <div class="flex" style="justify-content: left; margin: 10px;">
            施肥时间：<el-input :disabled="startForm.ferAmount != ''" type="number" style="width: 200px;" v-model="startForm.ferTime" placeholder="请输入施肥时间"></el-input>
          </div>
        </div>
        <div v-else>
          <div>{{ '确定要' + contDialog.content + '吗？' }}</div>
        </div>
      </div>
      <div v-else>{{ '确定要' + contDialog.content + '吗？' }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSFJInfoByCode, sendMessageByCode, controlSFJByCode } from '../utils/getxx'

export default {
  name: 'FertilizationSystem',
  data() {
    return {
      code: 'GZXM',
      csh: false,
      currentDateTime: '',
      controlMode: 'local',
      workMode: 'manual',
      alarmDialogVisible: false,
      currentTab: 0,
      input: '',
      smallTab: 0,

      currentIndex: 0,
      dynamicstyle: "", // 桶名字动态切换
      currentSlide: 0, // 存储当前桶
      tong1: ['施 肥 桶 A', '施 肥 桶 B', '施 肥 桶 C'], 
      tong: [
        {
          id: 0,
          value: '',
          name: '施肥桶A',
        },
        {
          id: 1,
          value: '',
          name: '施肥桶B',
        },
        {
          id: 3,
          value: '',
          name: '施肥桶C',
        }
      ],
      content: '',
      dialogVisible: false,
      currentMode: '', // 存储当前点击的mode
      contDialog: {}, //对话框内容信息
      startForm: {    //  启动表单内容
        ferAmount: '',
        ferTime: ''
      },
      btn: [
        {
          id: 0,
          content: '启动施肥机',
          value: '',
        },
        {
          id: 1,
          content: '停止施肥机',
          value: '',
        },
      ]

    }
  },
  mounted() {
    this.deviceName = this.$route.query.deviceName
    this.init()
    this.setStyle()
    this.updateCurrentDateTime()
    setInterval(this.updateCurrentDateTime, 1000)
    setInterval(this.init, 10000)
  },
  methods: {
    init() {
      getSFJInfoByCode({ deviceName: this.deviceName, code: this.code }).then(response => {
        this.dataSource = response
        if (this.dataSource.ctrl == 0) {
          this.controlMode = 'local'
        } else {
          this.controlMode = 'remote'
        }

        if (this.dataSource.mode == 0) {
          this.workMode = 'manual'
        } else {
          this.workMode = 'auto'
        }
        this.csh = true
      })
    },
    initsx() {
      getSFJInfoByCode({ deviceName: this.deviceName, code: this.code }).then(response => {
        this.dataSource = response
        if (this.dataSource.ctrl == 0) {
          this.controlMode = 'local'
        } else {
          this.controlMode = 'remote'
        }

        if (this.dataSource.mode == 0) {
          this.workMode = 'manual'
        } else {
          this.workMode = 'auto'
        }
        this.$message({
          message: '数据已刷新',
          type: 'success'
        })
        this.csh = true
      })
    },
    nextSlide() { // 下一个
      this.currentSlide = (this.currentSlide + 1) % this.tong1.length// 每次指针加一
      this.setStyle()
    },
    prevSlide() { // 上一个
      this.currentSlide = (this.currentSlide - 1 + this.tong1.length) % this.tong1.length// 每次减一，为负数时循环
      this.setStyle()
    },
  
    setStyle() { // 实现桶切换
      this.dynamicstyle = `translateX(-${this.currentSlide * 100}%)`;
    },

    toggleControlMode() { // 本地远程模式切换
      sendMessageByCode({ deviceName: this.deviceName, category: '85', data: this.controlMode === 'local' ? '0201' : '0200', code: this.code }).then(response => {
        // this.init()
        if (response.includes('命令已下发')) {
          this.$message({
            message: '命令已下发',
            type: 'success'
          })
          this.controlMode = this.controlMode === 'local' ? 'remote' : 'local'
        } else {
          this.$message(response.replaceAll('"',''))
        }
      })
    },
    toggleWorkMode() { // 手动自动模式切换
      sendMessageByCode({ deviceName: this.deviceName, category: '85', data: this.workMode === 'manual' ? '0101' : '0100', code: this.code }).then(response => {
        // this.init()
        if (response.includes('命令已下发')) {
          this.$message({
            message: '命令已下发',
            type: 'success'
          })
          this.workMode = this.workMode === 'manual' ? 'auto' : 'manual'
        } else {
          this.$message(response.replaceAll('"',''))
        }
      })
    },
    onJiaShui() {
      controlSFJByCode({ deviceName: this.deviceName, command: '74', data: '06', code: this.code }).then(response => {
        // this.init()
        if (response.includes('命令已下发')) {
          this.$message({
            message: '命令已下发',
            type: 'success'
          })
        } else {
          this.$message(response.replaceAll('"',''))
        }
      })
    },
    onTingZhiJiaShui() {
      controlSFJByCode({ deviceName: this.deviceName, command: '75', data: '06', code: this.code }).then(response => {
        // this.init()
        if (response.includes('命令已下发')) {
          this.$message({
            message: '命令已下发',
            type: 'success'
          })
        } else {
          this.$message(response.replaceAll('"',''))
        }
      })
    },
    onQiDong() {
      var ferAmount = 0
      var ferTime = 0
      if (this.startForm.ferAmount != '') {
        ferAmount = this.startForm.ferAmount
        if (ferAmount > 255) {
          this.$message.error('施肥量不可大于255');
          return
        }
      }
      if (this.startForm.ferTime != '') {
        ferTime = this.startForm.ferTime
        if (ferTime > 255) {
          this.$message.error('施肥时间不可大于255');
          return
        }
      }
      controlSFJByCode({ deviceName: this.deviceName, command: '74', data: '04_' + ferAmount + '_' + ferTime, code: this.code }).then(response => {
        // this.init()
        if (response.includes('命令已下发')) {
          this.$message({
            message: '命令已下发',
            type: 'success'
          })
        } else {
          this.$message(response.replaceAll('"',''))
        }
      })
    },
    onTingZhi() {
      controlSFJByCode({ deviceName: this.deviceName, command: '74', data: '03', code: this.code }).then(response => {
        // this.init()
        if (response.includes('命令已下发')) {
          this.$message({
            message: '命令已下发',
            type: 'success'
          })
        } else {
          this.$message(response.replaceAll('"',''))
        }
      })
    },
    showAlarmDialog() {
      this.alarmDialogVisible = true
    },
    openDialog(mode) {
      // 处理不同模式的对话框逻辑
      this.currentMode = mode

      if (mode === 'controlMode') {// 切换本地和远程
        this.dialogVisible = true
        this.contDialog = {
          content: '切换' + (this.controlMode === 'local' ? '远程模式' : '本地模式'),
          targetFun: this.toggleControlMode
        }
      } else if (mode === 'workMode') {// 切换手动和自动
        this.dialogVisible = true
        this.contDialog = {
          content: '切换' + (this.workMode === 'auto' ? '手动模式' : '自动模式'),
          targetFun: this.toggleWorkMode
        }
      } else if (mode === 'startMode') {// 施肥机启动
        this.startForm = {  
          ferAmount: '',
          ferTime: ''
        }
        this.dialogVisible = true
        this.contDialog = {
          content: '启动施肥机',
          targetFun: this.onQiDong
        }
      } else if (mode == 'stopMode') {// 施肥机停止
        this.dialogVisible = true
        this.contDialog = {
          content: '停止施肥机',
          targetFun: this.onTingZhi
        }
      } else if (mode == 'waterPlus') {// 加水
        this.dialogVisible = true
        this.contDialog = {
          content: '加水',
          targetFun: this.onJiaShui
        }
      } else if (mode == 'waterStop') {// 停止加水
        this.dialogVisible = true
        this.contDialog = {
          content: '停止加水',
          targetFun: this.onTingZhiJiaShui
        }
      } else if (mode == 'stir') {// 搅拌
        this.$message({
          message: '为了保障您的操作安全，远程搅拌功能已禁用，请通过本地面板直接操作！',
          type: 'warning'
        })
        // this.dialogVisible = true
        // this.contDialog = {
        //   content: '搅拌',
        //   targetFun: this.isFun
        // }
      } else if (mode == 'stirStop') {// 停止搅拌
        this.dialogVisible = true
        this.contDialog = {
          content: '停止搅拌',
          targetFun: this.isFun
        }
      } else if (mode == 'init') {// 清零
        this.dialogVisible = true
        this.contDialog = {
          content: '清零数据',
          targetFun: this.isFun
        }
      } else if (mode == 'getParams') {// 读取
        this.dialogVisible = true
        this.contDialog = {
          content: '读取',
          targetFun: this.isFun
        }
      } else if (mode == 'setUp') {// 设置
        this.dialogVisible = true
        this.contDialog = {
          content: '设置',
          targetFun: this.isFun
        }
      } else if (mode == 'getParams1') {// 读取
        this.dialogVisible = true
        this.contDialog = {
          content: '读取',
          targetFun: this.isFun
        }
      } else if (mode == 'setUp1') {// 设置
        this.dialogVisible = true
        this.contDialog = {
          content: '设置',
          targetFun: this.isFun
        }
      } else if (mode == 'getParams2') {// 读取
        this.dialogVisible = true
        this.contDialog = {
          content: '读取',
          targetFun: this.isFun
        }
      } else if (mode == 'setUp2') {// 设置
        this.dialogVisible = true
        this.contDialog = {
          content: '设置',
          targetFun: this.isFun
        }
      } else if (mode == 'dan') {// 单通道
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成单通道',
          targetFun: this.isFun
        }
      } else if (mode == 'sanA') {// 三通道A
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成三通道A',
          targetFun: this.isFun
        }
      } else if (mode == 'sanB') {// 三通道B
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成三通道B',
          targetFun: this.isFun
        }
      } else if (mode == 'sanC') {// 三通道C
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成三通道C',
          targetFun: this.isFun
        }
      } else if (mode == 'sanAB') {// 三通道AB
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成三通道AB',
          targetFun: this.isFun
        }
      } else if (mode == 'sanAC') {// 三通道AC
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成三通道AC',
          targetFun: this.isFun
        }
      } else if (mode == 'sanBC') {// 三通道BC
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成三通道BC',
          targetFun: this.isFun
        }
      } else if (mode == 'sanABC') {// 三通道ABC
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成三通道ABC',
          targetFun: this.isFun
        }
      } else if (mode == 'danshuju') {// 单通道数据
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成单通道数据',
          targetFun: this.isFun
        }
      } else if (mode == 'bengshuju') {// 泵房数据
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成泵房数据',
          targetFun: this.isFun
        }
      } else if (mode == 'duoshuju') {// 多通道数据
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成多通道数据',
          targetFun: this.isFun
        }
      } else if (mode == 'ECPH') {// ECPH数据
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成ECPH数据',
          targetFun: this.isFun
        }
      } else if (mode == 'duoECPH') {// 多通道数据_ECPH
        this.dialogVisible = true
        this.contDialog = {
          content: '设置成多通道数据_ECPH',
          targetFun: this.isFun
        }
      }
    },
    closeDialog() {
      console.log(this.startForm);
      
      this.dialogVisible = false
      this.contDialog.targetFun()
    },

    isFun() {// 实现不同的接口
      if (1 === 1) {
        return 1 + 1
      }
    },
    updateCurrentDateTime() {
      const now = new Date()
      this.currentDateTime = now.toLocaleString()
    }
  },
  
}
</script>

<style scoped>
/* 基础布局样式 */
.app-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  color: white;
  font-family: Arial, sans-serif;
}

/* 头部样式 */
.header {
  width: 90%;
  height: 15%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1%;
}

.title {
  font-size: 3vw;
  color: #FFFFFF;
  margin: 0;
}

.status-group {
  display: flex;
  align-items: center;
}

.time-display {
  font-size: 1.2vw;
  color: #FFFFFF;
  margin: 0 1vw;
}

.mode-btn {
  font-size: 1vw;
  padding: 0.5vw 1vw;
  margin: 0 0.5vw;
  background-color: transparent;
  border-color: #FFFFFF;
  color: #FFFFFF;
}

.alarm-btn {
  padding: 0;
}

.header-divider {
  width: 100%;
  height: 2.4vw;
  margin-top: 0.2vw;
}

/* 主内容区样式 */
.main-content {
  width: 90%;
  height: 70%;
  margin: 0 auto;
  margin-top: 1vw;
  /* display: flex;
  justify-content: space-between; */
}


.content {
  display: none;
  width: 100%;
  height: 100%;
  /* font-size: 16px;
  line-height: 1.6;
  color: #606266; */
}

.teb-main {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

/* 激活的内容项显示 */
.content.active {
  display: block;
  animation: fade 0.3s;
  /* 淡入动画 */
}

.left-content {
  width: 60%;
  height: 100%;
}

.data-panel {
  width: 100%;
  height: 65%;
  display: flex;
  flex-direction: column;
  border-radius: 0.5vw;
  overflow: hidden;
}

.sensor-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1vw;
  padding: 2vw;
}

.sensor-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.sensor-value {
  font-size: 2.5vw;
  color: #FFFFFF;
  margin-bottom: 0.5vw;
}

.sensor-label {
  font-size: 1vw;
  color: white;
}

.device-controls {
  height: 25%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* background: rgba(0, 0, 0, 0.5); */
  /* padding: 1vw; */
}

.device-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1vw;
}

.device-icon {
  width: 2vw;
  height: 2vw;
  margin-top: 0.5vw;
}

.control-btn {
  width: 8vw;
  height: 5vw;
  font-size: 1.2vw;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.control-btn>span {
  display: block;
  width: 100%;
}

/* 肥料桶样式 */
.fertilizer-tank {
  width: 40%;
  height: 80%;
  /* background: rgba(0, 0, 0, 0.5); */
  border-radius: 0.5vw;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.tong-status {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  width: 100%;
  height: 20%;
  font-size: 2vw;
  overflow: hidden;
  font-weight: bold;
}

.tong-status span {
  width: 100%;
  white-space: nowrap;
  display: inline-block;
  position: absolute;
  white-space: pre-wrap;
}

.fertilizer-tank h3 {
  width: 100%;
  height: 15%;
  font-size: 1.8vw;
  color: white;
  display: flex;
  align-items: flex-end;
  justify-content: center;

}

.right-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.arrow {
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
}

.arrow-img {
  width: 3vw;
  height: 5vw;
}

.tank {
  width: 50%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.tank-status {
  width: 100%;
  height: 50%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.status-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2vw;
}

.value {
  color: #FFFFFF;
  font-size: 1.8vw;
}

.margin-left {
  margin-left: 1vw;
}

.valve-icon {
  width: 2vw;
  height: 2vw;
}

.action-group {
  display: flex;
  justify-content: space-between;
  /* margin-top: 1vw; */
}

.tank-btn {
  width: 6vw;
  height: 3vw;
  font-size: 1vw;
  padding: 0;
}

/* 二级内部菜单 */
.tabs-container-small {
  margin: 0 auto;
  width: 90%;
  height: 92%;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.tab-nav-small {
  display: flex;
  justify-content: center;
  height: 3vw;
  margin: 0;
  padding: 0;
  margin-top: 1vw;
}

.tab-item-small {

  flex: 1;
  list-style: none;
  text-align: center;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #00000079;
  transition: all 0.3s;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8vw;

}


/* 鼠标悬停效果 */
.tab-item-small:hover {
  color: #000;

  background: #FFFFFF;

}

/* 激活的标签项样式 */
.tab-item-small.active {
  color: #000;
  background-color: #FFFFFF;
  font-weight: bold;
}

.tab-content-small {
  /* border: 1px solid salmon; */
  border: 0;
  border-radius: 4px 4px 0 0;
  height: 100%;
}

/* 内容项默认隐藏 */
.content-small {
  display: none;
  /* font-size: 16px; */
  line-height: 1.6;
  color: #FFFFFF;
  padding: 2vw;

}

/* 激活的内容项显示 */
.content-small.active {
  display: block;
  animation: fade 0.1s;

}

.tab-main-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 1vw 0;
}

.tab-row-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tab-row-font {
  font-size: 1.7vw;
  color: white;
  white-space: pre-wrap;
}

.tab-row-input {
  width: 20vw;
}

::v-deep .el-input__inner {
  height: 3vw !important;
  box-sizing: border-box;
  /* padding: 0; */
}

::v-deep .el-input__inner:not(:placeholder-shown) {
  /* top: -8px; */
  /* height: 2vw; */
  font-size: 1vw;
  /* color: #409EFF; */
}

.tab-button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tab-main-button {
  font-size: 1.2vw;
  margin: 1vw;
  color: #000000;
  background-color: #FFFFFF;
}

/* 底部导航样式 */
.footer {
  width: 90%;
  height: 13%;
  margin: 0 auto;

}

.nav-tabs {
  height: 90%;
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
}

.tab-item {
  /* width: 20%; */
  flex: 1;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
  font-size: 1.8vw;
  cursor: pointer;
  color: #FFFFFF;
  border: 0.1vw solid #0cf3ef;
}



.tab-item:hover {
  color: #0cf3ef;
  background: transparent;
}

.tab-item.active {
  color: #0cf3ef;
  background-image: url('/img/选中背景.png');
}

.tab-item:nth-child(1):not(.active):hover .tab-img {
  content: url('/img/znsf_1.png');

}

.tab-item:nth-child(2):not(.active):hover .tab-img {
  content: url('/img/cssz_1.png');
}




.tab-img {
  margin-top: 0.2vw;
  width: 2vw;
  height: 2vw;
}

/* 对话框样式 */
.alarm-list {
  /* display: flex;
  justify-content: center;
  align-items: center; */
  font-size: 1vw;
}

.alarm-item {
  display: flex;
  align-items: center;
  margin-bottom: 1vw;
}

.alarm-status-icon {
  width: 1.2vw;
  height: 1.2vw;
  margin-right: 0.5vw;
}


/* 测试 */
.el-col {
  border-radius: 4px;
}

.text1-3 {
  font-size: 1.3vw;
}

.top0-5 {
  margin-top: 0.5vw;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>